import AppPageComponentGroup from "./AppPageComponentGroup";

import "./AppPageComponentGroup.scss";

export { AppPageComponentGroup };
